'use strict';

const _=require('pulsar-utils/dist-es6/_');
const PersonStatisticsViewModel=require('../../../dist-es6/client/viewModels/personStatisticsViewModel');let

FatigueTrendsPersonViewModel=class FatigueTrendsPersonViewModel extends PersonStatisticsViewModel{
constructor(...args){
super(...args);
}

get averageFatigueOnDuty(){
return this._statistics.averageFatigueOnDuty;
}

get averageHoursOfSleepPerDay(){
return this._statistics.averageHoursOfSleepPerDay;
}

get maxFatigueOnDuty(){
return this._statistics.maxFatigueOnDuty;
}

get hasDuties(){
return this._statistics.numDuties>0;
}

get numDuties(){
return this._statistics.numDuties;
}

get dutyHours(){
return this._statistics.dutyHours;
}

get numTripsOnDuty(){
return this._statistics.numTripsOnDuty;
}

get fatigueDistribution(){
return this._statistics.fatigueDistribution;
}};


module.exports=FatigueTrendsPersonViewModel;
//# sourceMappingURL=fatigueTrendsPersonViewModel.js.map
